import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    $(document).ready(function () {
        var selector = "[data-ui]";
        gsap.registerPlugin(ScrollTrigger);

        if ($(selector).length) {
            if (log) console.log("%cfunction_ui-color.js initialized", "color: green;");
            var $ui = $("header");
            var offset = getCssVarValue("--blh");

            $(selector).each(function () {
                var $instance = $(this);
                var color = $instance.attr("data-ui");

                ScrollTrigger.create({
                    scroller: window,
                    trigger: $instance[0],
                    start: "top top+=" + offset,
                    end: "bottom top",
                    onToggle: function (_self) {
                        if (_self.isActive) {
                            $ui.addClass(`c-${color}`);
                        } else {
                            $ui.removeClass(`c-${color}`);
                        }
                    },
                    toggleActions: "play reverse play reverse",
                });
            });
        }
    });
})();
